module.exports = __webpack_public_path__ + "media/images/front/recorte_2-4bfd24771fe1353fd07cf8955f5a6f15.png";